<!--<input type="file" (change)="onFileSelected($event)">-->
<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <img src="./assets/images/loading04.gif" alt="loading" style="width: 300px;" />
    <!-- <p style="color: black" class="card-title">กำลังโหลดข้อมูล...</p> -->
</ngx-spinner>
<!-- content -->
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <!-- แบบค้นหาข้อมูล -->
        <div class="card no-print">
            <div class="card-header row bg-info ">
                <div class="col-md-2">
                    <i class="fas fa-clipboard-list"></i>
                    ไฟล์สินเชื่อ
                </div>
                <div class="col-md-4 text-center">
                    <mat-form-field appearance="fill">
                        <mat-label>เลือกปี</mat-label>
                        <mat-select disableRipple required [(ngModel)]="sYear" (ngModelChange)="selectYear()">
                            <mat-option *ngFor="let item of listYear" [value]="item">
                                ปีการผลิต - {{item[2]}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-2 text-center">
                    <button type="button" class="btn btn-tool" (click)="selectYear();"><i
                            class="fas fa-sync"></i></button>
                </div>
            </div>

            <div class="card-body">
                <form *ngIf="editer">
                    <div class="row justify-content-md-center">

                        <div class="col-md-2 text-center">
                            <div class="form-group">
                                <label for="exampleFormControlFile1"> file {{files_d.name}} </label>
                                <input mat-raised-button type="file" multiple class="form-control-file"
                                    id="exampleFormControlFile1" type="file" accept=".pdf, .xls, .xlsx, .doc, .docx"
                                    (change)="onFileSelected($event)">
                                <a *ngIf="url_load" href={{url_load}} target="_blank">
                                    -ไฟล์ที่อัพโหลด- <i class="fas fa-file-download nav-icon"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-4 text-center">
                            <mat-form-field class="example-full-width" appearance="fill">
                                <mat-label>หมายเหตุ</mat-label>
                                <input matInput required placeholder="..ระบุหมายเหตุ..(ต้องมี)" [(ngModel)]="doc"
                                    maxlength="200" name="doc">
                            </mat-form-field>
                        </div>
                        <div class="col-md-2 text-center">
                            <div class="button-row">
                                <button mat-raised-button color="primary" (click)="insert_to()"
                                    [disabled]="!url_load || !doc">
                                    บันทึกข้อมูล
                                </button>
                            </div>
                        </div>

                        <div class="text-center" *ngIf="isUploading">
                            <div class="spinner-border text-success" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p>กำลังอัพโหลดไฟล์...</p>
                        </div>
                    </div>
                </form>

                <hr />
                <div class="row justify-content-md-center">
                    <div class="col col-lg-4">
                        <mat-form-field class="example-full-width" style="text-align:center">
                            <input matInput [(ngModel)]="text_f" [ngModelOptions]="{standalone: true}"
                                placeholder="คำค้นหา" style="text-align:center">
                            <button *ngIf="text_f" matSuffix mat-icon-button aria-label="Clear" (click)="text_f=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row justify-content-md-center">

                    <div class="col-md-10">
                        <div class="example-label">{{DataList.length}} : รายการ </div>
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr style="text-align:center">
                                    <th>.</th>
                                    <th>ปี</th>
                                    <th>วันที่บันทึก</th>
                                    <th>ผู้อัพโหลดไฟล์</th>
                                    <th>หมายเหตุ</th>
                                    <th>ไฟล์</th>
                                    <th>ยกเลิก</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="text-align:center" *ngFor="let dt of DataList | filter:text_f;; index as i;">
                                    <td> {{i+1}}</td>
                                    <td> {{dt.year}}</td>
                                    <td> {{THtoLocal(dt.dateAdd)}}</td>
                                    <td style="text-align:left"> {{dt.supname}}</td>
                                    <td style="text-align:left"> {{dt.doc}}</td>
                                    <td>
                                        <a mat-mini-fab href="{{dt.link}}" target="_blank" *ngIf="dt.link">
                                            <span class="material-icons">
                                                cloud_download
                                            </span>
                                        </a>
                                    </td>
                                    <td>
                                        <button mat-icon-button color="warn" (click)="cancel_to(dt)"
                                            [disabled]="!editer" aria-label="ยกเลิกข้อมูล">
                                            <mat-icon>highlight_off</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<app-footer></app-footer>